var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "div",
        { staticClass: "filter-container" },
        [
          _c("el-input", {
            staticClass: "filter-input filter-item",
            attrs: { placeholder: "任务ID", clearable: "" },
            nativeOn: {
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.handleFilter($event)
              },
            },
            model: {
              value: _vm.listQuery.jobId,
              callback: function ($$v) {
                _vm.$set(_vm.listQuery, "jobId", $$v)
              },
              expression: "listQuery.jobId",
            },
          }),
          _vm._v(" "),
          _c("el-input", {
            staticClass: "filter-input filter-item",
            attrs: { placeholder: "关键字", clearable: "" },
            nativeOn: {
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.handleFilter($event)
              },
            },
            model: {
              value: _vm.listQuery.keyword,
              callback: function ($$v) {
                _vm.$set(_vm.listQuery, "keyword", $$v)
              },
              expression: "listQuery.keyword",
            },
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { float: "right" } },
            [
              _c(
                "el-button",
                {
                  directives: [{ name: "waves", rawName: "v-waves" }],
                  staticClass: "filter-item",
                  attrs: { type: "primary" },
                  on: { click: _vm.handleFilter },
                },
                [
                  _c("svg-icon", {
                    staticStyle: { "margin-right": "5px" },
                    attrs: { "icon-class": "search" },
                  }),
                  _vm._v("查询\n        "),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  directives: [{ name: "waves", rawName: "v-waves" }],
                  staticClass: "filter-item",
                  attrs: { type: "primary" },
                  on: { click: _vm.handleReset },
                },
                [
                  _c("svg-icon", {
                    staticStyle: { "margin-right": "5px" },
                    attrs: { "icon-class": "reload" },
                  }),
                  _vm._v("重置\n        "),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "has",
                      rawName: "v-has",
                      value: "job:save",
                      expression: "'job:save'",
                    },
                  ],
                  staticClass: "filter-item",
                  attrs: { type: "primary" },
                  on: { click: _vm.handleCreate },
                },
                [
                  _c("svg-icon", {
                    staticStyle: { "margin-right": "5px" },
                    attrs: { "icon-class": "plus" },
                  }),
                  _vm._v("新增\n        "),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticStyle: { "background-color": "#ffffff" },
          attrs: { id: "screenfull-container" },
        },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              key: _vm.tableKey,
              ref: "multipleTable",
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.list,
                border: "",
                fit: "",
                "highlight-current-row": "",
              },
            },
            [
              _vm.columnHeaders[0].isShow
                ? _c("el-table-column", {
                    attrs: { label: "任务ID", prop: "id" },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.columnHeaders[1].isShow
                ? _c("el-table-column", {
                    attrs: { label: "任务名称", prop: "jobName" },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.columnHeaders[2].isShow
                ? _c("el-table-column", {
                    attrs: { label: "定时信息" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    scope.row.timeExpressionType +
                                      " " +
                                      (scope.row.timeExpression
                                        ? scope.row.timeExpression
                                        : "")
                                  ) +
                                  "\n          "
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3377730502
                    ),
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.columnHeaders[3].isShow
                ? _c("el-table-column", {
                    attrs: { label: "执行类型" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.translateExecuteType(
                                      scope.row.executeType
                                    )
                                  ) +
                                  "\n          "
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      4048660090
                    ),
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.columnHeaders[4].isShow
                ? _c("el-table-column", {
                    attrs: { label: "处理器类型" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.translateProcessorType(
                                      scope.row.processorType
                                    )
                                  ) +
                                  "\n          "
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1526173946
                    ),
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.columnHeaders[5].isShow
                ? _c("el-table-column", {
                    attrs: { label: "状态" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("el-switch", {
                                attrs: {
                                  "active-color": "#13ce66",
                                  "inactive-color": "#ff4949",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.changeJobStatus(scope.row)
                                  },
                                },
                                model: {
                                  value: scope.row.enable,
                                  callback: function ($$v) {
                                    _vm.$set(scope.row, "enable", $$v)
                                  },
                                  expression: "scope.row.enable",
                                },
                              }),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      4090932515
                    ),
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "操作", "min-width": "150px", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      var $index = ref.$index
                      return [
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "has",
                                rawName: "v-has",
                                value: "job:update",
                                expression: "'job:update'",
                              },
                            ],
                            attrs: { size: "mini", type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.handleUpdate(row)
                              },
                            },
                          },
                          [_vm._v("\n              编辑\n            ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "has",
                                rawName: "v-has",
                                value: "job:run",
                                expression: "'job:run'",
                              },
                            ],
                            attrs: { size: "mini", type: "warning" },
                            on: {
                              click: function ($event) {
                                return _vm.handleRunRow(row)
                              },
                            },
                          },
                          [_vm._v("\n              运行\n            ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "has",
                                rawName: "v-has",
                                value: "job:history",
                                expression: "'job:history'",
                              },
                            ],
                            attrs: { size: "mini", type: "success" },
                            on: {
                              click: function ($event) {
                                return _vm.handleRunHistoryRow(row)
                              },
                            },
                          },
                          [_vm._v("\n              运行记录\n            ")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("pagination", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.total > 0,
                expression: "total > 0",
              },
            ],
            attrs: {
              page: _vm.listQuery.index,
              limit: _vm.listQuery.pageSize,
              total: _vm.total,
            },
            on: {
              "update:page": function ($event) {
                _vm.listQuery.index = $event
              },
              "update:limit": function ($event) {
                _vm.listQuery.pageSize = $event
              },
              pagination: _vm.getList,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            title: _vm.textMap[_vm.dialogStatus],
            visible: _vm.dialogFormVisible,
            width: "77%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogFormVisible = $event
            },
          },
          scopedSlots: _vm._u([
            {
              key: "footer",
              fn: function () {
                return [
                  _c(
                    "div",
                    { staticClass: "dialog-footer" },
                    [
                      _c(
                        "el-button",
                        {
                          on: {
                            click: function ($event) {
                              _vm.dialogFormVisible = false
                            },
                          },
                        },
                        [_vm._v("\n            取消\n          ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "primary",
                            disabled: _vm.disabledStatus,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.saveJob()
                            },
                          },
                        },
                        [_vm._v("\n            确认\n          ")]
                      ),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c(
            "el-form",
            {
              ref: "dataForm",
              staticStyle: { width: "100%" },
              attrs: {
                rules: _vm.rules,
                model: _vm.modifiedJobForm,
                "label-position": _vm.labelPosition,
                "label-width": "110px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "任务名称", prop: "jobName" } },
                [
                  _c("el-input", {
                    attrs: { clearable: "" },
                    model: {
                      value: _vm.modifiedJobForm.jobName,
                      callback: function ($$v) {
                        _vm.$set(_vm.modifiedJobForm, "jobName", $$v)
                      },
                      expression: "modifiedJobForm.jobName",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "任务描述" } },
                [
                  _c("el-input", {
                    attrs: { clearable: "" },
                    model: {
                      value: _vm.modifiedJobForm.jobDescription,
                      callback: function ($$v) {
                        _vm.$set(_vm.modifiedJobForm, "jobDescription", $$v)
                      },
                      expression: "modifiedJobForm.jobDescription",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "任务参数" } },
                [
                  _c("el-input", {
                    attrs: { clearable: "" },
                    model: {
                      value: _vm.modifiedJobForm.jobParams,
                      callback: function ($$v) {
                        _vm.$set(_vm.modifiedJobForm, "jobParams", $$v)
                      },
                      expression: "modifiedJobForm.jobParams",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "定时信息", prop: "scheduleInfo" } },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 5 } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: "时间表达式类型",
                                clearable: "",
                              },
                              model: {
                                value: _vm.modifiedJobForm.timeExpressionType,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.modifiedJobForm,
                                    "timeExpressionType",
                                    $$v
                                  )
                                },
                                expression:
                                  "modifiedJobForm.timeExpressionType",
                              },
                            },
                            _vm._l(
                              _vm.timeExpressionTypeOptions,
                              function (item) {
                                return _c("el-option", {
                                  key: item.key,
                                  attrs: { label: item.label, value: item.key },
                                })
                              }
                            ),
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 16 } },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder:
                                "CRON填写CRON表达式，毫秒级任务填写整数，API和工作流无需填写",
                              clearable: "",
                            },
                            model: {
                              value: _vm.modifiedJobForm.timeExpression,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.modifiedJobForm,
                                  "timeExpression",
                                  $$v
                                )
                              },
                              expression: "modifiedJobForm.timeExpression",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 3 } },
                        [
                          _c(
                            "el-button",
                            {
                              staticStyle: { "padding-left": "10px" },
                              attrs: { type: "text" },
                              on: { click: _vm.onClickValidateTimeExpression },
                            },
                            [_vm._v("校验定时参数")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "执行配置", prop: "executeConfig" } },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 5 } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { placeholder: "执行类型", clearable: "" },
                              model: {
                                value: _vm.modifiedJobForm.executeType,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.modifiedJobForm,
                                    "executeType",
                                    $$v
                                  )
                                },
                                expression: "modifiedJobForm.executeType",
                              },
                            },
                            _vm._l(_vm.executeTypeOptions, function (item) {
                              return _c("el-option", {
                                key: item.key,
                                attrs: { label: item.label, value: item.key },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 5 } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                placeholder: "处理器类型",
                                clearable: "",
                              },
                              model: {
                                value: _vm.modifiedJobForm.processorType,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.modifiedJobForm,
                                    "processorType",
                                    $$v
                                  )
                                },
                                expression: "modifiedJobForm.processorType",
                              },
                            },
                            _vm._l(_vm.processorTypeOptions, function (item) {
                              return _c("el-option", {
                                key: item.key,
                                attrs: { label: item.label, value: item.key },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 14 } },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: _vm.verifyPlaceholder(
                                _vm.modifiedJobForm.processorType
                              ),
                              clearable: "",
                            },
                            model: {
                              value: _vm.modifiedJobForm.processorInfo,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.modifiedJobForm,
                                  "processorInfo",
                                  $$v
                                )
                              },
                              expression: "modifiedJobForm.processorInfo",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  scopedSlots: _vm._u([
                    {
                      key: "label",
                      fn: function () {
                        return [
                          _vm._v("\n            运行时配置\n            "),
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                content: "0代表不限制",
                                placement: "top",
                              },
                            },
                            [
                              _c("svg-icon", {
                                attrs: { "icon-class": "info-circle" },
                              }),
                            ],
                            1
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _vm._v(" "),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "最大实例数", clearable: "" },
                            scopedSlots: _vm._u([
                              {
                                key: "prepend",
                                fn: function () {
                                  return [_vm._v("最大实例数")]
                                },
                                proxy: true,
                              },
                            ]),
                            model: {
                              value: _vm.modifiedJobForm.maxInstanceNum,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.modifiedJobForm,
                                  "maxInstanceNum",
                                  $$v
                                )
                              },
                              expression: "modifiedJobForm.maxInstanceNum",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "单机线程并发度",
                              clearable: "",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "prepend",
                                fn: function () {
                                  return [_vm._v("单机线程并发度")]
                                },
                                proxy: true,
                              },
                            ]),
                            model: {
                              value: _vm.modifiedJobForm.concurrency,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.modifiedJobForm,
                                  "concurrency",
                                  $$v
                                )
                              },
                              expression: "modifiedJobForm.concurrency",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "运行时间限制（毫秒）",
                              clearable: "",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "prepend",
                                fn: function () {
                                  return [_vm._v("运行时间限制（毫秒）")]
                                },
                                proxy: true,
                              },
                            ]),
                            model: {
                              value: _vm.modifiedJobForm.instanceTimeLimit,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.modifiedJobForm,
                                  "instanceTimeLimit",
                                  $$v
                                )
                              },
                              expression: "modifiedJobForm.instanceTimeLimit",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  scopedSlots: _vm._u([
                    {
                      key: "label",
                      fn: function () {
                        return [
                          _vm._v("\n            重试配置\n            "),
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                content: "0代表不限制",
                                placement: "top",
                              },
                            },
                            [
                              _c("svg-icon", {
                                attrs: { "icon-class": "info-circle" },
                              }),
                            ],
                            1
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _vm._v(" "),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "Instance重试次数",
                              clearable: "",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "prepend",
                                fn: function () {
                                  return [_vm._v("Instance重试次数")]
                                },
                                proxy: true,
                              },
                            ]),
                            model: {
                              value: _vm.modifiedJobForm.instanceRetryNum,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.modifiedJobForm,
                                  "instanceRetryNum",
                                  $$v
                                )
                              },
                              expression: "modifiedJobForm.instanceRetryNum",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "Task重试次数",
                              clearable: "",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "prepend",
                                fn: function () {
                                  return [_vm._v("Task重试次数")]
                                },
                                proxy: true,
                              },
                            ]),
                            model: {
                              value: _vm.modifiedJobForm.taskRetryNum,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.modifiedJobForm,
                                  "taskRetryNum",
                                  $$v
                                )
                              },
                              expression: "modifiedJobForm.taskRetryNum",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  scopedSlots: _vm._u([
                    {
                      key: "label",
                      fn: function () {
                        return [
                          _vm._v("\n            机器配置\n            "),
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                content: "0代表不限制",
                                placement: "top",
                              },
                            },
                            [
                              _c("svg-icon", {
                                attrs: { "icon-class": "info-circle" },
                              }),
                            ],
                            1
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _vm._v(" "),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "最低CPU核心数",
                              clearable: "",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "prepend",
                                fn: function () {
                                  return [_vm._v("最低CPU核心数")]
                                },
                                proxy: true,
                              },
                            ]),
                            model: {
                              value: _vm.modifiedJobForm.minCpuCores,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.modifiedJobForm,
                                  "minCpuCores",
                                  $$v
                                )
                              },
                              expression: "modifiedJobForm.minCpuCores",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "最低内存(GB)",
                              clearable: "",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "prepend",
                                fn: function () {
                                  return [_vm._v("最低内存(GB)")]
                                },
                                proxy: true,
                              },
                            ]),
                            model: {
                              value: _vm.modifiedJobForm.minMemorySpace,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.modifiedJobForm,
                                  "minMemorySpace",
                                  $$v
                                )
                              },
                              expression: "modifiedJobForm.minMemorySpace",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "最低磁盘空间(GB)",
                              clearable: "",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "prepend",
                                fn: function () {
                                  return [_vm._v("最低磁盘空间(GB)")]
                                },
                                proxy: true,
                              },
                            ]),
                            model: {
                              value: _vm.modifiedJobForm.minDiskSpace,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.modifiedJobForm,
                                  "minDiskSpace",
                                  $$v
                                )
                              },
                              expression: "modifiedJobForm.minDiskSpace",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "集群配置" } },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 16 } },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder:
                                "执行机器地址（可选，不指定代表全部；多值英文逗号分割）",
                              clearable: "",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "prepend",
                                fn: function () {
                                  return [
                                    _vm._v(
                                      "执行机器地址（可选，不指定代表全部；多值英文逗号分割）"
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ]),
                            model: {
                              value: _vm.modifiedJobForm.designatedWorkers,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.modifiedJobForm,
                                  "designatedWorkers",
                                  $$v
                                )
                              },
                              expression: "modifiedJobForm.designatedWorkers",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "最大执行机器数量（0代表不限）",
                              clearable: "",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "prepend",
                                fn: function () {
                                  return [
                                    _vm._v("最大执行机器数量（0代表不限）"),
                                  ]
                                },
                                proxy: true,
                              },
                            ]),
                            model: {
                              value: _vm.modifiedJobForm.maxWorkerCount,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.modifiedJobForm,
                                  "maxWorkerCount",
                                  $$v
                                )
                              },
                              expression: "modifiedJobForm.maxWorkerCount",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.timeExpressionValidatorVisible
        ? _c(
            "el-dialog",
            {
              attrs: {
                "close-on-click-modal": false,
                visible: _vm.timeExpressionValidatorVisible,
              },
              on: {
                "update:visible": function ($event) {
                  _vm.timeExpressionValidatorVisible = $event
                },
              },
            },
            [
              _c("TimeExpressionValidator", {
                attrs: {
                  "time-expression": _vm.modifiedJobForm.timeExpression,
                  "time-expression-type":
                    _vm.modifiedJobForm.timeExpressionType,
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: { title: "录入报警人员", visible: _vm.alarmDialogFormVisible },
          on: {
            "update:visible": function ($event) {
              _vm.alarmDialogFormVisible = $event
            },
          },
          scopedSlots: _vm._u([
            {
              key: "footer",
              fn: function () {
                return [
                  _c(
                    "div",
                    { staticClass: "dialog-footer" },
                    [
                      _c(
                        "el-button",
                        {
                          on: {
                            click: function ($event) {
                              _vm.alarmDialogFormVisible = false
                            },
                          },
                        },
                        [_vm._v("\n            取消\n          ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "primary",
                            disabled: _vm.disabledStatus,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.registerAlarmUser()
                            },
                          },
                        },
                        [_vm._v("\n            确认\n          ")]
                      ),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c(
            "el-form",
            {
              ref: "alarmDataForm",
              staticStyle: { width: "100%" },
              attrs: {
                rules: _vm.rules,
                model: _vm.userRegisterForm,
                "label-position": _vm.labelPosition,
                "label-width": "90px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "姓名", prop: "username" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入", clearable: "" },
                    model: {
                      value: _vm.userRegisterForm.username,
                      callback: function ($$v) {
                        _vm.$set(_vm.userRegisterForm, "username", $$v)
                      },
                      expression: "userRegisterForm.username",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "邮箱", prop: "email" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入", clearable: "" },
                    model: {
                      value: _vm.userRegisterForm.email,
                      callback: function ($$v) {
                        _vm.$set(_vm.userRegisterForm, "email", $$v)
                      },
                      expression: "userRegisterForm.email",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "手机号", prop: "mobile" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入", clearable: "" },
                    model: {
                      value: _vm.userRegisterForm.phone,
                      callback: function ($$v) {
                        _vm.$set(_vm.userRegisterForm, "phone", $$v)
                      },
                      expression: "userRegisterForm.phone",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "WebHook" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入", clearable: "" },
                    model: {
                      value: _vm.userRegisterForm.webHook,
                      callback: function ($$v) {
                        _vm.$set(_vm.userRegisterForm, "webHook", $$v)
                      },
                      expression: "userRegisterForm.webHook",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }